import clsx from 'clsx'
import format from 'date-fns/format'
import React from 'react'
import { Link } from 'react-router-dom'
import InfoButton from '../InfoButton'

interface TimelineStatus {
  id: number
  icon: React.ReactElement
  checked: boolean
  checkedName: string
  activeName: string
  statusCreatedAt?: string | Date
  label: string
  message?: string
  infoContent?: string
}

interface TimelineProps {
  statusLogs: TimelineStatus[]
  orderId: string
  /** Oculta o link "Enviar documentos" (ex.: fluxo B2C/WA, origin REENVIO) */
  hideSendDocuments?: boolean
  /** Força exibição do link em pill_2 mesmo quando o step já está checked (ex.: status approved/created) */
  alwaysShowDocuments?: boolean
  /** Sobrescreve o destino padrão /enviar-receita/:id (ex.: /validacao-documentos/:uuid para Pill) */
  documentLinkUrl?: string
}

const Timeline: React.FC<TimelineProps> = ({ statusLogs, orderId, hideSendDocuments, alwaysShowDocuments, documentLinkUrl }) => {
  const isAssociationRoute = window.location.pathname.includes('/AreaAssociados')
  return (
    <div className="flex flex-col p-3">
      {statusLogs.map((status, index) => {
        const isCompleted = status.checked
        const isActive = !status.checked && !!status.statusCreatedAt

        // Mostra subtitle tanto para steps completos quanto para steps ativos (com data)
        // Se tem mensagem descritiva, usa ela. Senão usa o label
        const subtitle = status.statusCreatedAt
          ? `${status.message || status.label} - ${format(new Date(status.statusCreatedAt), 'dd/MM/yyyy - HH:mm')}`
          : ''

        return (
          <div key={status.id} className="relative flex items-start pb-8">
            {index !== statusLogs.length - 1 && (
              <div
                className={clsx('absolute bottom-0 left-4 top-8 w-1 -translate-x-1/2 transform', {
                  'bg-primary-200': isCompleted,
                  'bg-blue-300': isActive,
                  'bg-neutral-100': !isCompleted && !isActive
                })}
              />
            )}
            <div
              className={clsx('z-10 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full', {
                'bg-primary-200 text-primary-800': isCompleted,
                'bg-blue-500 text-white': isActive,
                'bg-neutral-200 text-neutral-500': !isCompleted && !isActive
              })}>
              {React.cloneElement(status.icon, { size: 20 })}
            </div>
            <div className="ml-6 min-w-0 flex-1">
              <div className="flex items-center">
                <h3
                  className={clsx('text-md font-normal', {
                    'text-neutral-800': isCompleted || isActive,
                    'text-neutral-500': !isCompleted && !isActive
                  })}>
                  {status.checked ? status.checkedName : status.activeName}
                </h3>
                {status.infoContent && <InfoButton content={status.infoContent} />}
              </div>
              {subtitle && <p className="mt-1 break-words text-sm text-gray-500">{subtitle}</p>}
              {(status.id === 2 || status.id === 'pill_2') &&
                (!status.checked || (status.id === 'pill_2' && alwaysShowDocuments)) &&
                !isAssociationRoute &&
                !hideSendDocuments && (
                  <Link
                    className="mt-1 block text-sm text-primary-800"
                    to={documentLinkUrl || `/enviar-receita/${orderId}`}>
                    {status.refused ? 'Reenviar receita' : 'Enviar documentos'}
                  </Link>
                )}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Timeline
